import {
  DEPARTMENT_PREVIEW,
  DEPARTMENT_NEW,
  DEPARTMENT_UPDATE,
  DEPARTMENT_REMOVE,
  DEPARTMENT_PROCESS_SUCCESS,
  DEPARTMENT_DATASOURCE_SUCCESS,
  DEPARTMENT_SEARCH,
  DEPARTMENT_PROCESS_RESET
  
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case DEPARTMENT_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case DEPARTMENT_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case DEPARTMENT_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case DEPARTMENT_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case DEPARTMENT_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case DEPARTMENT_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case DEPARTMENT_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case DEPARTMENT_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}